/**
 * @format
 * @module lib/commercial/keytar/promotion/template
 */
import Template, { BLOCKOUT_TYPES } from "lib/commercial/keytar/Template";
import { isDesktop } from "utils/detect";
import tgamConfig from "config/tgam";
import { hasProp } from "utils/utils";
import CONSTS from "lib/consts";

/** @type {String} */
const wallName = "promotionWall";

const blockoutType =
  isDesktop() || tgamConfig.meta.isStoryInteractivePage
    ? BLOCKOUT_TYPES.EVERYTHING // static modal displayed
    : BLOCKOUT_TYPES.HEADER_NAV_ACCESSIBLE; // iframe takeover displayed

const props = {
  blockoutType,
  /**
   * @method render
   * @description Always render the paywall template.
   * @returns {Promise<Boolean>} true if rendered
   */
  render() {
    // modal view - regular regwall (no darwin or hermes support)
    // This is setup in: /resources/scripts/src/ui/user-states.js
    if (hasProp(window, "tgam.ui.regwall.show")) {
      window.tgam.ui.regwall.show({
        url: CONSTS.URLS.REGISTER.ELECTION,
        width: 500,
        height: 720,
        uid: "prowall",
        wallName,
        template: null
      });
    }
    return Promise.resolve(true);
  }
};

export default new Template(props);
